import V1 from '@/system-modules/update/v1/SysUpdateV1'
import { ISysUpdateModule } from '@/contracts/system-modules/update/ISysUpdateModule'
import { Provider } from '@/contracts/core/provider/entity/Provider'
import SystemModuleConfig from '@/contracts/system/configs/SystemModuleConfig'

export class SysUpdateProvider extends Provider<ISysUpdateModule> {
  realizations: Record<string, ISysUpdateModule> = {
    v1: V1(),
  }
}

const instance: { module: ISysUpdateModule | null } = { module: null }

export function SysUpdateProviderModule(): ISysUpdateModule {
  const version = SystemModuleConfig.getUpdateVersion()

  if (!instance.module) {
    instance.module = new SysUpdateProvider().module(version)
  }

  return instance.module
}
